import { useTranslation } from 'react-i18next';

export default function AboutTrust() {
  const { t } = useTranslation();

  return (
    <section className="py-16 md:py-24 bg-background-50 px-4 md:px-6">
      <div className="max-w-[1280px] mx-auto">
        <div className="flex flex-col lg:flex-row gap-12">
          <div className="flex-1">
            <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-900 mb-6">
              {t('section1.title')}
            </h2>
            <p className="text-foreground-600 text-base leading-relaxed mb-4">
              {t('section1.desc')}
            </p>
            <p className="text-foreground-500 text-sm leading-relaxed mb-6">
              Per molti utenti italiani acquistare prodotti internazionali può sembrare complicato:
            </p>
            <ul className="space-y-2 mb-6">
              <li className="flex items-center gap-2 text-sm text-foreground-600">
                <i className="ri-close-circle-line text-accent-500"></i> {t('section1.problem1')}
              </li>
              <li className="flex items-center gap-2 text-sm text-foreground-600">
                <i className="ri-close-circle-line text-accent-500"></i> {t('section1.problem2')}
              </li>
              <li className="flex items-center gap-2 text-sm text-foreground-600">
                <i className="ri-close-circle-line text-accent-500"></i> {t('section1.problem3')}
              </li>
              <li className="flex items-center gap-2 text-sm text-foreground-600">
                <i className="ri-close-circle-line text-accent-500"></i> {t('section1.problem4')}
              </li>
            </ul>
            <p className="text-foreground-600 text-sm leading-relaxed">{t('section1.solution')}</p>

            <div className="mt-8 overflow-x-auto">
              <table className="w-full text-sm border-collapse">
                <thead>
                  <tr className="border-b border-background-300">
                    <th className="text-left py-3 pr-4 font-semibold text-foreground-800">Caratteristica</th>
                    <th className="text-left py-3 pr-4 font-semibold text-foreground-800">Itaobuy Spreadsheet</th>
                    <th className="text-left py-3 font-semibold text-foreground-800">Ricerca tradizionale</th>
                  </tr>
                </thead>
                <tbody>
                  <tr className="border-b border-background-200">
                    <td className="py-3 pr-4 text-foreground-600">Organizzazione prodotti</td>
                    <td className="py-3 pr-4 text-accent-600 font-medium">Alta</td>
                    <td className="py-3 text-foreground-400">Bassa</td>
                  </tr>
                  <tr className="border-b border-background-200">
                    <td className="py-3 pr-4 text-foreground-600">Confronto informazioni</td>
                    <td className="py-3 pr-4 text-accent-600 font-medium">Facile</td>
                    <td className="py-3 text-foreground-400">Difficile</td>
                  </tr>
                  <tr className="border-b border-background-200">
                    <td className="py-3 pr-4 text-foreground-600">Analisi prezzo</td>
                    <td className="py-3 pr-4 text-accent-600 font-medium">Rapida</td>
                    <td className="py-3 text-foreground-400">Manuale</td>
                  </tr>
                  <tr className="border-b border-background-200">
                    <td className="py-3 pr-4 text-foreground-600">Risparmio tempo</td>
                    <td className="py-3 pr-4 text-accent-600 font-medium">Elevato</td>
                    <td className="py-3 text-foreground-400">Limitato</td>
                  </tr>
                  <tr>
                    <td className="py-3 pr-4 text-foreground-600">Processo decisionale</td>
                    <td className="py-3 pr-4 text-accent-600 font-medium">Più semplice</td>
                    <td className="py-3 text-foreground-400">Complesso</td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>

          <div className="flex-1">
            <div className="bg-accent-50/50 rounded-3xl p-8 md:p-10 h-full flex flex-col justify-center">
              <div className="grid grid-cols-3 gap-6 text-center">
                <div className="border-r border-background-300 pr-4">
                  <p className="font-heading text-3xl md:text-4xl font-bold text-accent-500">500+</p>
                  <p className="text-xs text-foreground-500 mt-1">Prodotti analizzati</p>
                </div>
                <div className="border-r border-background-300 pr-4">
                  <p className="font-heading text-3xl md:text-4xl font-bold text-accent-500">14</p>
                  <p className="text-xs text-foreground-500 mt-1">Categorie</p>
                </div>
                <div>
                  <p className="font-heading text-3xl md:text-4xl font-bold text-accent-500">24/7</p>
                  <p className="text-xs text-foreground-500 mt-1">Guida disponibile</p>
                </div>
              </div>

              <div className="mt-10">
                <h3 className="font-heading text-xl font-bold text-foreground-900 mb-4">
                  {t('section2.title')}
                </h3>
                <p className="text-foreground-600 text-sm leading-relaxed mb-3">
                  {t('section2.desc')}
                </p>
                <p className="text-foreground-700 text-sm font-medium">{t('section2.conclusion')}</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}